import { APIClient, ApiQueryParams } from "@frontend/api-utils";
import { RequirementExtendedListResponse, RequirementQueryParams } from "@frontend/stock/types";


export class RequirementExtendedClient extends APIClient {
    public static readonly endpoint = '/stock-api/ext/v1';

    public static async fetchExtendedRequirements(queryParams?: ApiQueryParams<RequirementQueryParams>): Promise<RequirementExtendedListResponse> {
        return await this.apiPaginated<RequirementExtendedListResponse, RequirementQueryParams>(`${this.endpoint}/requirements`, queryParams);
    }
}